import { toLuxon } from './to-luxon';
import { DateTime } from 'luxon';

export function toFormValue(value: any): any {
  let result: any = {};
  Object.keys(value).forEach((k) => {
    if (value[k] && Array.isArray(value[k])) {
      result[k] = value[k].map((v: any) => {
        return typeof v === 'object' ? toFormValue(v) : v;
      });
    } else if (value[k] && typeof value[k] === 'object') {
      if (value[k] instanceof DateTime || k.endsWith('File')) {
        result[k] = value[k];
      } else if (value[k].id) {
        result[k] = value[k].id;
      } else if (value[k].date) {
        result[k] = toLuxon(value[k]);
      } else {
        result[k] = toFormValue(value[k]);
      }
    } else {
      result[k] = value[k];
    }
  });
  return result;
}
